<app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

<div class="flex justify-between mt-5">
    <h2 class="font-medium">Roles</h2>
    <button (click)="router.navigate(['/admin/roles/add'])" color="primary" mat-flat-button>
        <mat-icon>add</mat-icon>
        {{'COMMON.ADD_NEW' | translate}}
    </button>
</div>

<div class="mt-5">
    <div class="example-container">
        <mat-form-field class="example-form-field">
            <mat-label>{{'COMMON.SEARCH' | translate}}</mat-label>
            <input class="border-transparent focus:border-transparent focus:ring-0" [(ngModel)]="filter.keyWord"
                [ngModelOptions]="{standalone: true}" matInput type="text" (keydown.enter)="searchByKeyword()"
                placeholder="{{'COMMON.SEARCH' | translate}}">
            <button matSuffix mat-icon-button aria-label="Clear">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>

<div class="mt-5">
    <table mat-table class="ws-table" [dataSource]="dataSource">

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <div class="flex items-center">
                    <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                    <button *ngIf="selection.selected && selection.selected.length > 0" mat-icon-button
                        aria-label="close dialog" mat-dialog-close (click)="deleteRole(0)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> {{'COMMON.NAME' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> {{'COMMON.DESCRIPTION' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <ng-container matColumnDef="numberOfEmployees">
            <th mat-header-cell *matHeaderCellDef> {{'DEPARTMENTS.NUMBER_EMPLOYEE' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.numberOfEmployees}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="editRole(element.id)">
                        <mat-icon>edit</mat-icon>
                        <span> {{'COMMON.EDIT' | translate}}</span>
                    </button>
                    <button *ngIf="element.canDelete" mat-menu-item (click)="deleteRole(element.id)">
                        <mat-icon>delete</mat-icon>
                        <span>{{'COMMON.DELETE' | translate}}</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <qms-paginator [length]="totalCount" [pageSize]="filter.pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)='pageEvent($event)' [size]='"medium"'>
    </qms-paginator>
</div>